import React, { useEffect, useState, useRef } from "react";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import { useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import IntellipayStoreOnlyMode from "./IntellipayStoreOnlyMode";

const WIDGET_READY_FALLBACK_MS = 5000;

export const ModalUpdateIntelliPay = () => {
  const { eventId } = useParams();
  const { user } = useAuthUser() || {};
  const buttonRef = useRef(null);
  const widgetClickedRef = useRef(false);
  const [loading, setLoading] = useState(true);
  const [isWidgetReady, setIsWidgetReady] = useState(false);
  const accountPath =
    user?.role === "athlete"
      ? "/athlete/account"
      : user?.role === "highschool"
        ? "/highschool/account"
        : "/university/account";

  const setIsOpenRegister = () => {
    window.location.href = accountPath;
  };

  const tryClickButton = () => {
    if (isWidgetReady && buttonRef.current && !widgetClickedRef.current) {
      widgetClickedRef.current = true;
      buttonRef.current.click();
      setLoading(false);
      return true;
    }
    return false;
  };

  const setButtonRef = (node) => {
    buttonRef.current = node;
    if (node) tryClickButton();
  };

  useEffect(() => {
    if (tryClickButton()) return;

    if (widgetClickedRef.current) return;

    const fallback = setTimeout(() => {
      setLoading(false);
      toast.error("Payment widget failed to load. Please try again.");
      setIsOpenRegister();
    }, WIDGET_READY_FALLBACK_MS);

    return () => clearTimeout(fallback);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isWidgetReady]);

  return (
    <>
      {loading && (
        <div className="flex absolute top-0 left-0 justify-center items-center h-[100%] w-full bg-black/10">
          <FontAwesomeIcon
            icon={faSpinner}
            spin
            size="4x"
            className="text-blue-800"
          />
        </div>
      )}
      <button
        className="ipayfield hidden"
        data-ipayname="submit"
        ref={setButtonRef}
      ></button>

      <IntellipayStoreOnlyMode
        userEmail={user.email}
        userId={user.id}
        paymentAmount={0}
        eventId={eventId}
        onRegistrationSuccess={() => {
          setIsOpenRegister();
        }}
        closeAction={true}
        onClose={() => {
          window.location.href = accountPath;
        }}
        onIntellipayReady={setIsWidgetReady}
      />
    </>
  );
};
